(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["module", "exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(module, exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod, mod.exports);
    global.jaJP = mod.exports;
  }
})(this, function (module, exports) {
  "use strict";

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = {
    "rich": {
      "validator": {
        "type": {
          "array": "データタイプはアレイであること",
          "url": "有効なURLを入力してください",
          "date": "有効な日付を選択してください",
          "email": "有効なメールアドレスを入力してください",
          "string": "文字を入力してください",
          "tel": "有効な携帯電話番号を入力してください",
          "number": "数字を入力してください"
        },
        "max": {
          "tel": "{{config}} 文字を超えないでください",
          "number": "{{config}} を超えないでください",
          "email": "{{config}} 文字を超えないでください",
          "url": "{{config}} 文字を超えないでください",
          "date": "{{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 以前の時間を選択してください",
          "array": "最大 {{config}} 件選択できます",
          "string": "{{config}} 文字を超えないでください"
        },
        "min": {
          "string": "{{config}} 文字以上を入力",
          "array": "最低 {{config}} 件選択してください",
          "email": "{{config}} 文字以上を入力",
          "tel": "{{config}} 文字以上を入力",
          "number": "{{config}} 以上であること",
          "date": "{{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 以降の時間を選択してください",
          "url": "{{config}} 文字以上を入力"
        },
        "len": {
          "string": "{{config}} 文字で入力してください",
          "number": "長さは {{config}} と等しいこと",
          "array": "{{config}} 件選択してください",
          "tel": "{{config}} 文字で入力してください",
          "date": "{{config | toLocaleDateString(\"yyyy年MM月dd日\")}} 以前の時間を選択してください",
          "email": "{{config}} 文字で入力してください",
          "url": "{{config}} 文字で入力してください"
        },
        "notWhitespace": "スペースは無効です",
        "custom": "認証できませんでした",
        "pattern": "フォーマットエラー",
        "required": "必須項目です"
      },
      "timePicker": {
        "minutes": "分",
        "hours": "点",
        "today": "今日",
        "formatDate": "M月D日",
        "selectTime": "日時を選択",
        "now": "現在"
      },
      "textArea": {
        "placeholder": "入力してください…"
      },
      "resultPage": {
        "networkSubtext": "アップロード",
        "emptyText": "データがありません",
        "networkText": "ネットワーク接続エラー",
        "lostText": "アクセス先のページが見つかりません"
      },
      "common": {
        "selectText": "選択してください",
        "ok": "OK",
        "cancel": "キャンセル",
        "confirm": "確定"
      },
      "segmentPicker": {
        "next": "次へ",
        "prev": "戻る"
      }
    }
  };
  module.exports = exports["default"];
});